import { Box } from "@mui/material"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else.js"
import { ScrollIntoView } from "lib/@components/scrollIntoView"

export function IsSelectable({ children, item, selectedId }) {
    const isSelected = !!selectedId && (item.id === selectedId || item._id === selectedId)
    return (
        <If value={isSelected}>
            <Box chosenScheduleId={selectedId} sx={{ bgcolor: "action.selected" }}>
                {children}
                <ScrollIntoView />
            </Box>
            <Else>{children}</Else>
        </If>
    )
}
